import { useMemo } from 'react'
import { EquipmentSection } from './equipment-section'
import { LaborSection } from './labor-section'
import { MaterialsSection } from './materials-section'
import { MiscSection } from './misc-section'
import type { PricingItem, LineItem, CreateLineItemPayload } from '@/types'

function filterByService(items: PricingItem[], service: string): PricingItem[] {
  const target = service.toLowerCase()
  return items.filter((item) => {
    if (!item.service) return false
    const itemServices = item.service.split(',').map((s) => s.trim().toLowerCase())
    return itemServices.some((s) => s === target)
  })
}

interface SealCoatGradingPanelProps {
  estimateId: string
  pricingItems: PricingItem[]
  lineItems: LineItem[]
  isPublicWorks?: boolean
  defaultFuelChargePercent?: number
  scopeData?: string
  onAddItem: (payload: CreateLineItemPayload) => Promise<void>
  onUpdateItem: (itemId: string, data: Partial<CreateLineItemPayload> & { lineTotal?: number }) => Promise<void>
  onDeleteItem: (itemId: string) => Promise<void>
  onWriteupRowDisable?: (writeupRowId: string) => void
  onWriteupFieldUpdate?: (writeupRowId: string, fieldName: string, value: number) => void
}

export function SealCoatGradingPanel({
  pricingItems, lineItems, isPublicWorks, defaultFuelChargePercent, scopeData, onAddItem, onUpdateItem, onDeleteItem, onWriteupRowDisable,
}: SealCoatGradingPanelProps) {
  const filteredPricingItems = useMemo(
    () => filterByService(pricingItems, 'seal coating'),
    [pricingItems],
  )

  return (
    <div className="ec-panel">
      <MaterialsSection
        lineItems={lineItems}
        pricingItems={filteredPricingItems}
        section="seal-coat"
        serviceFilter="Seal Coating"
        scopeData={scopeData}
        onAddItem={onAddItem}
        onUpdateItem={onUpdateItem}
        onDeleteItem={onDeleteItem}
        onWriteupRowDisable={onWriteupRowDisable}
      />
      <EquipmentSection
        lineItems={lineItems}
        pricingItems={filteredPricingItems}
        section="seal-coat"
        serviceFilter="Seal Coating"
        defaultFuelChargePercent={defaultFuelChargePercent}
        onAddItem={onAddItem}
        onUpdateItem={onUpdateItem}
        onDeleteItem={onDeleteItem}
      />
      <LaborSection
        lineItems={lineItems}
        pricingItems={filteredPricingItems}
        section="seal-coat"
        serviceFilter="Seal Coating"
        isPublicWorks={isPublicWorks}
        onAddItem={onAddItem}
        onUpdateItem={onUpdateItem}
        onDeleteItem={onDeleteItem}
      />
      <MiscSection
        lineItems={lineItems}
        pricingItems={filteredPricingItems}
        section="seal-coat"
        serviceFilter="Seal Coating"
        onAddItem={onAddItem}
        onUpdateItem={onUpdateItem}
        onDeleteItem={onDeleteItem}
      />
    </div>
  )
}
